import React from "react";
import taxi from "../images/taxi-image.png";
import MyButton from "../components/MyButton";

const Main = (props) => {
  const setCurrentPage = props.changePage;

  const handleButtonClick = () => {
    // Your custom button click logic here
    setCurrentPage("set-quiz");
    console.log('THIS WORKING=?');
  };

  return (
    <div className="mx-10">
      <img src={taxi} className="mb-10" alt="taxi" />
      <div>Selecciona que vols aprendre:</div>
      <div className="button-Container">
        <MyButton label="Carrers" onPress={handleButtonClick} />
        <MyButton label="Direccions" onPress={handleButtonClick} disabled/>
        <MyButton label="Punts d'interes" onPress={handleButtonClick} disabled/>
      </div>
    </div>
  );
};
export default Main;
